import type { CallCost } from '../api';
import type { T } from '../i18n';

const n = (x: number) => x.toLocaleString();
const usd = (x: number | null) => (x === null ? '—' : x < 0.01 ? `$${x.toFixed(4)}` : `$${x.toFixed(3)}`);
const label = (t: T, key: string, fallback: string) => (t(key) === key ? fallback : t(key));

/** ADR-057: what the call used per service (models, voice, listening, line) and an estimated cost. */
export const CallCostCard = ({ t, cost }: { t: T; cost: CallCost }) => (
  <div className="card">
    <div className="row-between">
      <h3>{t('calls.cost.title')}</h3>
      <strong>{usd(cost.usd)} · ₺{cost.try.toFixed(2)}</strong>
    </div>
    <table className="table">
      <thead>
        <tr><th>{t('calls.cost.service')}</th><th>{t('calls.cost.used')}</th><th className="num">{t('calls.cost.cost')}</th></tr>
      </thead>
      <tbody>
        {cost.rows.map((r, i) => (
          <tr key={i}>
            {r.service === 'ai' && (
              <>
                <td>{t('calls.cost.ai')} · {label(t, `platform.calls.role.${r.role}`, r.role)}<div className="mono small muted">{r.model}</div></td>
                <td className="small">{t('calls.cost.tokens', { calls: n(r.calls), in: n(r.inputTokens), cached: n(r.cachedInputTokens), out: n(r.outputTokens) })}</td>
              </>
            )}
            {r.service === 'tts' && (
              <>
                <td>{t('calls.cost.tts')}</td>
                <td className="small">{t('calls.cost.chars', { engine: label(t, `calls.cost.engine.${r.engine}`, r.engine), chars: n(r.characters), credits: n(r.credits) })}</td>
              </>
            )}
            {r.service === 'stt' && (
              <>
                <td>{t('calls.cost.stt')}</td>
                <td className="small">{t('calls.cost.minutes', { minutes: r.minutes.toFixed(2), streams: String(r.streams) })}</td>
              </>
            )}
            {r.service === 'line' && (
              <>
                <td>{t('calls.cost.line')}</td>
                <td className="small">{t('calls.cost.lineMinutes', { minutes: r.minutes.toFixed(2) })}</td>
              </>
            )}
            <td className="num">{usd(r.usd)}</td>
          </tr>
        ))}
        <tr>
          <td><strong>{t('calls.cost.total')}</strong></td>
          <td />
          <td className="num"><strong>{usd(cost.usd)}</strong></td>
        </tr>
      </tbody>
    </table>
    {cost.unpriced.length > 0 && <p className="hint">{t('calls.cost.unpriced', { models: cost.unpriced.join(', ') })}</p>}
    <p className="hint">{t('calls.cost.note')}</p>
  </div>
);
